import React from 'react';
import './SuperAdminStyles.css';

const BackupRestore = () => {
  return (
    <div className="backup-restore">
      <h2>Backup & Restore</h2>
      <div className="backup-container">
        <div className="backup-card">
          <h3>Automatic Backups</h3>
          <p>Configure and schedule automatic system backups.</p>
        </div>
        <div className="backup-card">
          <h3>Manual Backup</h3>
          <p>Create manual backups of system data.</p>
        </div>
        <div className="backup-card">
          <h3>Restore Data</h3>
          <p>Restore system from previous backup files.</p>
        </div>
      </div>
    </div>
  );
};

export default BackupRestore;
